import { useState } from 'react';
import { PartyPopper } from 'lucide-react';
import ModalShell from '../ui/ModalShell';
import Dropdown from '../receptura/Dropdown';
import { SECTION_COLOR, hlavicky } from './komunikace';

/**
 * „Díky" kolegovi — zpráva do kanálu Všichni (vidí celý tým) a záznam pro
 * Hodnocení v Lidech. `kolega` předvyplní komu (z karty kolegy).
 */
export default function Podekovat({ isDark, lide = [], kolega = null, onClose, onHotovo }) {
    const [komu, setKomu] = useState(kolega?.id ?? null);
    const [text, setText] = useState('');
    const [ukladam, setUkladam] = useState(false);
    const [chyba, setChyba] = useState(null);
    const lze = komu && text.trim() && !ukladam;

    const poslat = async () => {
        if (!lze) return;
        setUkladam(true);
        setChyba(null);
        try {
            const res = await fetch('/api/chat/pochvala', { method: 'POST', headers: hlavicky(), body: JSON.stringify({ uzivatel_id: komu, text: text.trim() }) });
            const d = await res.json().catch(() => ({}));
            if (!res.ok) { setChyba(d.error || 'Nepodařilo se.'); return; }
            onHotovo?.(d);
        } catch { setChyba('Chyba sítě.'); } finally { setUkladam(false); }
    };

    const hrana = isDark ? 'rgba(255,255,255,0.12)' : 'var(--border-default)';
    const popisek = { fontSize: 11, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--text-muted)', margin: '14px 0 6px' };

    return (
        <ModalShell onClose={onClose} isDark={isDark} nadpis={kolega ? `Poděkovat: ${kolega.jmeno}` : 'Poděkovat kolegovi'} ikona={PartyPopper} barva={SECTION_COLOR} sirka={460}
            paticka={(
                <div className="flex items-center gap-2">
                    {chyba && <span className="text-xs flex-1" style={{ color: '#EF4444' }}>{chyba}</span>}
                    <button type="button" onClick={poslat} disabled={!lze} className="rounded-lg font-semibold ml-auto"
                        style={{ height: 44, padding: '0 20px', background: SECTION_COLOR, color: '#fff', border: 'none', cursor: lze ? 'pointer' : 'not-allowed', opacity: lze ? 1 : 0.45 }}>
                        {ukladam ? 'Posílám…' : 'Poděkovat'}
                    </button>
                </div>
            )}>
            <div style={{ padding: '0 16px 16px' }}>
                {!kolega && (
                    <>
                        <p style={popisek}>Komu</p>
                        <Dropdown value={komu} onChange={setKomu} isDark={isDark} accent={SECTION_COLOR} height={42} placeholder="Vyberte kolegu"
                            options={lide.map(l => ({ value: l.id, label: l.jmeno }))} />
                    </>
                )}
                <p style={popisek}>Za co</p>
                <textarea value={text} onChange={e => setText(e.target.value)} rows={3} maxLength={500} autoFocus={!!kolega}
                    placeholder="Např. za záskok v neděli, zachránil(a) jsi večer"
                    style={{ width: '100%', borderRadius: 8, padding: '10px 12px', outline: 'none', fontSize: 15, lineHeight: 1.5, background: isDark ? 'rgba(0,0,0,0.35)' : 'var(--surface-raised)', border: `1px solid ${hrana}`, color: 'var(--text-primary)' }} />
                <p className="text-xs" style={{ color: 'var(--text-muted)', marginTop: 6 }}>Pošle se do kanálu Všichni — ať to vidí celý tým.</p>
            </div>
        </ModalShell>
    );
}
